// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"GreatResources_Wrapper__37n1r","Spacer":"GreatResources_Spacer__3L9Ff","GreatResources":"GreatResources_GreatResources__36DlR"};